module.exports = __webpack_public_path__ + "static/futurice-1f58fe5aaaddd7ea553cded388c08637.svg";